import { IPost, Post } from '@/common/models/data/dashboard/posts/post'
import { IPostSocialLinks, PostSocialLinks } from '@/common/models/data/dashboard/posts/post-social-links'

interface IPostShowResponse {
    post: IPost
    shares: IPostSocialLinks
    similar: Array<IPost>
}

class PostShowResponse implements IPostShowResponse {
    post = new Post()
    shares = new PostSocialLinks()
    similar: Array<Post> = []

    constructor (data?: IPostShowResponse) {
        if (data !== undefined) {
            this.post = new Post(data.post)
            this.shares = new PostSocialLinks(data.shares)
            this.similar = data.similar.map(entry => new Post(entry))
        }
    }
}

export {
    IPostShowResponse,
    PostShowResponse
}
